import { render, staticRenderFns } from "./msgCode.vue?vue&type=template&id=7ab63ba7&scoped=true&"
import script from "./msgCode.vue?vue&type=script&lang=js&"
export * from "./msgCode.vue?vue&type=script&lang=js&"
import style0 from "./msgCode.vue?vue&type=style&index=0&id=7ab63ba7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ab63ba7",
  null
  
)

export default component.exports